import { useEffect, useState } from "react";

import { ApiError, apiSend } from "../api/client";

/** Landing page for the link in the confirmation email: /verify-email. */

function params(): { uid: string; token: string } {
  const search = new URLSearchParams(location.search);
  return { uid: search.get("uid") ?? "", token: search.get("token") ?? "" };
}

function goHome() {
  location.replace("/");
}

export function VerifyEmailPage() {
  const [state, setState] = useState<"working" | "done" | "failed">("working");
  const [message, setMessage] = useState("E-Mail-Adresse wird bestätigt …");

  useEffect(() => {
    const { uid, token } = params();
    apiSend<{ detail: string }>("POST", "/api/auth/verify-email", { uid, token })
      .then((response) => {
        setState("done");
        setMessage(response.detail);
      })
      .catch((error) => {
        setState("failed");
        setMessage(error instanceof ApiError ? error.message : "Bestätigung fehlgeschlagen.");
      });
  }, []);

  return (
    <AuthShell title="E-Mail bestätigen">
      <p className={state === "failed" ? "hint auth-error" : "hint"}>{message}</p>
      {state !== "working" && (
        <div className="action-bar">
          <button className="btn" onClick={goHome}>
            Zur Anmeldung
          </button>
        </div>
      )}
    </AuthShell>
  );
}

function AuthShell({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="auth-wrap">
      <img src="/logo.png" alt="Autoflug" className="auth-logo" />
      <div className="panel auth-panel">
        <div className="panel-head">
          <h2>{title}</h2>
        </div>
        <div className="panel-body">{children}</div>
      </div>
    </div>
  );
}
